<template>
    <div class="lds-ring-wrapper"><div class="lds-ring"></div><div class="lds-ring"></div><div class="lds-ring"></div><div class="lds-ring"></div></div>
</template>

<script type="text/babel">
    import Vue from 'vue';

    export default Vue.extend({});
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    $vue-green: #2463b8;

    .lds-ring-wrapper {
        font-size: 10px;
        position: fixed;
        top: 50%;
        left: 50%;
        margin: -20px 0 0 -20px;
        width: 40px;
        height: 40px;
        text-indent: -9999em;
        z-index: 1100;
    }
    .lds-ring {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 40px;
        height: 40px;
        margin: 5px;
        border: 6px solid $vue-green;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: $vue-green transparent transparent transparent;
    }
    .lds-ring:nth-child(1) {
        animation-delay: -0.45s;
    }
    .lds-ring:nth-child(2) {
        animation-delay: -0.3s;
    }
    .lds-ring:nth-child(3) {
        animation-delay: -0.15s;
    }
    .lds-ring:nth-child(4) {
        border-color: lighten($vue-green, 25%) transparent transparent transparent;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
